export default {
  view: 'preview',
  image: {},
  appliedEffects: {
    blur: 0,
    crop: null,
    enhance: 0,
    flip: false,
    grayscale: false,
    invert: false,
    mirror: false,
    rotate: 0,
    sharp: 0,
  },
  otherModifiers: '',
}
